// Organize them alphabetically

export const SAJ_ROUTES = {
  AccountList: '/account/select', // exist only in the Admin app
  Candidates: '/recruiting/candidates',
  Dashboard: '/recruiting/dashboard',
  InterviewAvailability: '/business/interview-availability',
  InterviewScheduled: '/business/interview-availability/scheduled',
  LmPreviousApplicants: '/recruiting/candidates/previous-applicants',
  LocationsList: '/business/locations',
  PostingList: '/recruiting/postings',
  /**
   * Partial route - append interviewId
   */
  VideoInterview: '/recruiting/candidates/interview/',
};
